var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-4 pa-sm-8",attrs:{"fluid":""}},[(_vm.hasRole(_vm.AdminUserPermissions.PAYMENT_VIEW))?_c('AccountTable'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }